import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function Faq({ testIdPrefix = 'faq' }) {
  const { t } = useTranslation('faq');
  const items = t('items', { returnObjects: true });
  const [open, setOpen] = useState(null);

  return (
    <ul className="border-t border-black/10" data-testid={`${testIdPrefix}-list`}>
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <li key={i} className="border-b border-black/10">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              className="w-full flex items-center justify-between gap-6 py-6 md:py-7 text-left group"
              aria-expanded={isOpen}
              data-testid={`${testIdPrefix}-toggle-${i}`}
            >
              <span className="font-display text-base md:text-lg font-semibold text-brand-primary group-hover:text-brand-accent transition-colors">
                {item.q}
              </span>
              <motion.span
                className="shrink-0 text-brand-accent"
                animate={{ rotate: isOpen ? 180 : 0 }}
                transition={{ duration: 0.22, ease: 'easeOut' }}
              >
                <ChevronDown size={18} strokeWidth={1.5} />
              </motion.span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  key="content"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <div
                    className="pb-7 pr-10 text-brand-text leading-[1.8] max-w-[68ch]"
                    data-testid={`${testIdPrefix}-answer-${i}`}
                  >
                    {item.a}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </li>
        );
      })}
    </ul>
  );
}
